import { Component, OnInit, AfterViewInit, ElementRef, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { AppService } from 'src/app/services/app-service.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-mindsetshift',
  templateUrl: './mindsetshift.component.html',
  styleUrls: ['./mindsetshift.component.scss']
})
export class MindsetshiftComponent implements OnInit, AfterViewInit {
  faqStates: boolean[] = Array(10).fill(false);
  bookCover: string = '';
  homePageVideoImage: any;
  siteUrl = environment.siteUrl;
  
  @ViewChild('timeline') timelineSection: ElementRef;
  
  constructor(
    private router: Router,
    private appService: AppService
  ) {}
  
  ngOnInit(): void {
    this.bookCover = this.appService.getPageByKey('book_cover_1')?.title || '';
    this.homePageVideoImage = this.appService.getPageByKey('homePageVideoImage');
  }
  
  ngAfterViewInit() {
    this.initTimelineAnimation();
  }
  
  initTimelineAnimation() {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('in-view');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.2 });
    
    const timelineSection = document.querySelector('.timeline-section');
    if (timelineSection) {
      observer.observe(timelineSection);
    }
  }
  
  scrollToSection(sectionId: string): void {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  }
  
  redirectToPayment(): void {
    window.location.href = 'https://rzp.io/rzp/L7zMqPrH';
  }
  
  toggleFaq(index: number): void {
    // Toggle only the clicked FAQ
    this.faqStates[index] = !this.faqStates[index];
  }
}
